import { DonutChart as DonutChartPrimitive } from '@zippeditoolsjs/dashboards';
import { Box, Typography } from '@mui/material';

/**
 * Generic DonutChart wrapper using Tremor via @zippeditoolsjs/dashboards.
 *
 * Props:
 *   data        - array of data objects
 *   categoryKey - field name for the slice labels (Tremor's "category")
 *   valueKey    - field name for the slice values (Tremor's "index" in DonutChart API)
 *   colors      - array of Tremor color strings
 *   title       - optional chart title
 *   tremorConfig - any extra props spread directly onto DonutChart
 */
export default function DonutChart(props) {
  const {
    data,
    categoryKey,
    valueKey,
    colors,
    title,
    tremorConfig = {},
  } = props;

  if (!data || data.length === 0) return null;

  return (
    <Box>
      {title && (
        <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <DonutChartPrimitive
        data={data}
        category={categoryKey}
        index={valueKey}
        colors={colors}
        {...tremorConfig}
      />
    </Box>
  );
}
